(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["banner-vehicle-compatibility"] && !Shopify.designMode) return;
  try {
    function updateCompatibilityBanner() {
    const displayIds = ['vehicle-year', 'make', 'model']; // display order
    const selectedVehicleObj = JSON.parse(
      localStorage.getItem('selectedVehicle') || '{}'
    );
    const { id: selectedVehicleId, url: selectedVehicleUrl } = selectedVehicleObj;
    const bannerElement = document.querySelectorAll('.banner-compatibility');

    bannerElement?.forEach(function (element) {
      const bannerMessageElement = element.querySelector('.banner-message');
      if (!bannerMessageElement) return;

      const bannerTextElement = bannerMessageElement.querySelector('.banner-text');

      if (selectedVehicleId) {
        const productTagList = element.querySelectorAll('tag');
        const hasMatchingTag =
        productTagList.length > 0 && Array.from(productTagList).some((tag) => tag.innerText === selectedVehicleId);
        const vehicleText = displayIds.map(key => selectedVehicleObj[key]?.toUpperCase().replace(/-/g, ' ')).join(' ');
        const compatibilityClass = hasMatchingTag ? 'compatible' : 'incompatible';
        const containerElement = bannerMessageElement.querySelector(`.banner-text .${compatibilityClass}`);
        const contentElement = containerElement.querySelector('.saved-vehicle-name') || containerElement;

        contentElement.innerText = vehicleText;
        contentElement.href = selectedVehicleUrl;
        containerElement.classList.remove('hidden');

        // toggle classes on banner container
        bannerMessageElement.classList.add(hasMatchingTag ? 'success' : 'critical');
        bannerMessageElement.classList.remove(hasMatchingTag ? 'critical' : 'success', 'hidden');
      } else {
        bannerTextElement.innerHTML = '';
        bannerMessageElement.classList.add('hidden');
      }
    });
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => updateCompatibilityBanner());
    document.addEventListener('shopify:section:reorder', () => updateCompatibilityBanner());
  }

  updateCompatibilityBanner();

  // Observe changes (ex: sidebar's filter changes in facet.js) to the product grid container
  // no need to disconnect, as observer should be disposed by browser when user is navigating to other pages
  const gridContainer = document.getElementById('ProductGridContainer'); // this element id is used for the product grid update in facet.js
  if (gridContainer) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        // direct descendant changes
        if (mutation.type === 'childList') {
          updateCompatibilityBanner();
        }
      });
    });
    observer.observe(gridContainer, {
      childList: true,
      subtree: false,
      attributes: false,
      characterData: false,
    });
  }
  } catch(e) { console.error(e); }
})();

})();
